module.exports = __webpack_public_path__ + "static/media/phychiatrist-mobile-cover.fc5e9c25.png";